import { ApiConfig } from '../ApiConfig.js';

/**
 * FormRoutes
 *
 * All available requests for getting or posting forms from the backend
 */
export default {

    /**
     * entryTypes
     *
     * @param params
     * @param path
     * @returns {Promise<Response>}
     */
    entryTypes(params = null) {

        return fetch(ApiConfig.baseURL + '/ajax/entry/getTypes?' + params, {
            method: 'GET',
            headers: ApiConfig.headers
        })
            .then(function (response) {
                if (response.status !== 200) {
                    throw response.status;
                } else {
                    return response.json();
                }
            });
    }
}